import { useLocation } from 'react-router';
import { useMemo } from 'react';
import { sidebarSearchKeywordAtom } from '../sidebarSearchKeywordAtom';
import { useAtomValue } from 'jotai';
import type { ViewModelJSON, ViewJSON } from './trpcSearchResultState';
import { ViewItemTitle } from '../../items/ViewItemTitle';
import { classNames } from '@framework/utils';

type Props = {
  view: ViewJSON;
  viewModel: ViewModelJSON;
};

export const SearchViewItem: React.FC<Props> = ({ view, viewModel }: Props) => {
  const searchKeyword = useAtomValue(sidebarSearchKeywordAtom);

  const { search } = useLocation();
  const isSelected = useMemo(() => {
    const query = new URLSearchParams(search);
    const targetViewId = query.get('targetView');
    return view.id === targetViewId;
  }, [view.id, search]);

  return (
    <div className={classNames('grow', isSelected ? 'bg-gray-300 hover:bg-gray-400' : 'hover:bg-gray-300')}>
      <ViewItemTitle
        viewId={view.id}
        viewIsLocked={view.isLocked}
        viewName={view.name}
        viewModelId={viewModel.id}
        searchKeyword={searchKeyword}
      />
    </div>
  );
};
